import React, { useEffect, useState } from "react";
import "react-sliding-pane/dist/react-sliding-pane.css";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Button,
  Typography,
  Container,
  Box,
  Grid,
  InputAdornment,
} from "@mui/material";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useDispatch, useSelector } from "react-redux";
import { appSelector } from "../redux/selector";
import {
  addCandidateAction,
  getCitiesAction,
  getCountriesAction,
  getJobTypesAction,
  getStatesAction,
  getZipcodesAction,
} from "../redux/action";
import { userSelector } from "../user-redux/selector";

function AddCandidate({ setAddCandidateFormOpen }) {
  const dispatch = useDispatch();

  const {
    statesList,
    citiesList,
    result,
    countriesList,
    jobTypesList,
    addCandidateResult,
  } = useSelector(appSelector);
  const { user } = useSelector(userSelector);

  const [resume, setResume] = useState();
  const [firstNameError, setFirstNameError] = useState(false); // New
  const [lastNameError, setLastNameError] = useState(false); // New
  const [emailError, setEmailError] = useState(false);
  const [jobTitleError, setJobTitleError] = useState(false); // New
  const [experienceError, setExperienceError] = useState(false); // New
  const [countryError, setCountryError] = useState(false);
  const [stateError, setStateError] = useState(false); // Add this line for state validation
  const [cityError, setCityError] = useState(false); // Add this line for city validation
  const [candidateStatusError, setCandidateStatusError] = useState(false);
  const [candidateStatusErrorMessage, setCandidateStatusErrorMessage] =
    useState("");
  const [jobTypeError, setJobTypeError] = useState(false);
  const [resumeError, setResumeError] = useState(false); // New
  const [disabled, setDisabled] = useState(false); // New
  const [relatedtitlesError, setRelatedtitleError] = useState(false); // New
  const [fileName, setFileName] = useState("");

  const [formData, setFormData] = useState({
    userid: user?.id,
    firstname: "",
    middlename: "",
    lastname: "",
    email: "",
    phone: "",
    date_of_birth: "",
    candidate_status: "Active",
    jobtitle: "",
    visatype: "GC",
    related_titles: "",
    experience: "",
    address: "",
    zipcode: "",
    countryid: 1,
    stateid: "",
    cityid: "",
    skills: [],
    summary: "",
    linkedInUrl: "",
    jobtypeid: "",
    availabledate: "",
    ratefrom: "",
    rateto: "",
    currentratetype: "",
    currentrate: "",
    gender: "",
    willingToRelocate: "No",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    // Email validation
    if (name === "email") {
      setEmailError(!validateEmail(value));
    }

    // First Name validation
    if (name === "firstname") {
      setFirstNameError(value.trim() === ""); // Check if it's empty
    }

    // Last Name validation
    if (name === "lastname") {
      setLastNameError(value.trim() === ""); // Check if it's empty
    }

    // Job Title validation
    if (name === "jobtitle") {
      setJobTitleError(value.trim() === ""); // Check if it's empty
    }

    // Experience validation
    if (name === "experience") {
      setExperienceError(value.trim() === ""); // Check if it's empty
    }

    // Country validation
    if (name === "countryid") {
      setCountryError(value === ""); // Check if it's empty
    }
    if (name === "related_titles") {
      setRelatedtitleError(value === ""); // Check if it's empty
    }

    // Candidate Status validation
    if (name === "candidate_status") {
      const isValidCandidateStatus = ["Active", "Inactive"].includes(value);
      // Update the error state accordingly
      setCandidateStatusError(!isValidCandidateStatus);
      // Update the error message
      setCandidateStatusErrorMessage(
        isValidCandidateStatus ? "" : "Please select a valid candidate status."
      );
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setResume(file);
    setResumeError(file === undefined || file === null);
  };

  const handleSkillsChange = (e) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      skills: value,
    }));
  };

  const handleEditorChange = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      summary: value,
    }));
  };

  useEffect(() => {}, [addCandidateResult]);

  const handleSubmit = () => {
    // Validate fields
    const isEmailValid = validateEmail(formData.email);
    const isFirstNameValid = formData.firstname.trim() !== "";
    const isLastNameValid = formData.lastname.trim() !== "";
    const isJobTitleValid = formData.jobtitle.trim() !== "";
    const isExperienceValid = formData.experience.trim() !== "";
    const isCountryValid = formData.countryid !== "";
    const isStateValid = formData.stateid !== ""; // Add this line for state validation
    const isCityValid = formData.cityid !== ""; // Add this line for city validation
    const isJobTypeValid = formData.jobtypeid !== ""; // Add this line for job type validation
    const isResumeValid = resume !== undefined && resume !== null;
    const isRelatedtitlesValid = formData.related_titles.trim() !== "";

    // Update error states and messages
    setEmailError(!isEmailValid);
    setFirstNameError(!isFirstNameValid);
    setLastNameError(!isLastNameValid);
    setJobTitleError(!isJobTitleValid);
    setExperienceError(!isExperienceValid);
    setCountryError(!isCountryValid);
    setStateError(!isStateValid); // Add this line for state validation
    setCityError(!isCityValid); // Add this line for city validation
    setJobTypeError(!isJobTypeValid); // Add this line for job type validation
    setResumeError(!isResumeValid);
    setRelatedtitleError(!isRelatedtitlesValid);

    // Define validation messages
    const emailErrorMessage = "Email is required and must be valid.";
    const firstNameErrorMessage = "First Name is required.";
    const lastNameErrorMessage = "Last Name is required.";
    const jobTitleErrorMessage = "Job Title is required.";
    const experienceErrorMessage = "Experience is required.";
    const countryErrorMessage = "Country is required";
    const stateErrorMessage = "State is required"; // Add this line for state validation
    const cityErrorMessage = "City is required"; // Add this line for city validation
    const candidateStatusErrorMessage =
      "Please select a valid candidate status.";
    const jobTypeErrorMessage = "Job Type is required"; // Add this line for job type validation
    const relatedtitleErrorMesssage = "Related title is required";
    // Display error messages
    if (
      !isEmailValid ||
      !isFirstNameValid ||
      !isLastNameValid ||
      !isJobTitleValid ||
      !isExperienceValid ||
      !isCountryValid ||
      !isStateValid || // Add this line for state validation
      !isCityValid || // Add this line for city validation
      !isRelatedtitlesValid ||
      candidateStatusError
    ) {
      // Handle error case

      return;
    }
    if (
      // ... (previous code)
      !isResumeValid
    ) {
      return;
    }

    // Submit if all validations pass
    if (
      isEmailValid &&
      isFirstNameValid &&
      isLastNameValid &&
      isJobTitleValid &&
      isExperienceValid &&
      isCountryValid &&
      isStateValid && // Add this line for state validation
      isCityValid &&
      isRelatedtitlesValid && // Add this line for city validation
      !candidateStatusError
    ) {
      if (resume !== "" && resume !== null) {
        setDisabled(true);
        dispatch(addCandidateAction(formData, user?.id, resume));
      } else {
        setDisabled(true);
        dispatch(addCandidateAction(formData, user?.id));
      }
    }
  };

  useEffect(() => {
    setDisabled(false);
  }, [result]);
  // Validate email format
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  useEffect(() => {
    dispatch(getCountriesAction());
    dispatch(getJobTypesAction());
    dispatch(getStatesAction(1));
  }, []);
  const handleCountryChange = (event) => {
    handleChange(event);
    setCountryError(event.target.value === ""); // Check if it's empty
    dispatch(getStatesAction(event.target.value));
  };

  // Inside handleChange function
  const handleStateChange = (event) => {
    handleChange(event);
    setStateError(event.target.value === ""); // Check if it's empty
    dispatch(getCitiesAction(event.target.value));
  };

  const handleCitiesChange = (event) => {
    handleChange(event);
    setCityError(event.target.value === "");
    //dispatch(getZipcodesAction(event.target.value)) // Check if it's empty
  };
  const handleJobTypeChange = (event) => {
    handleChange(event);
    setJobTypeError(event.target.value === ""); // Check if it's empty
  };

  return (
    <Container sx={{ padding: "10px" }}>
      <Typography
        variant="h5"
        align="left"
        gutterBottom
        style={{ fontSize: "18px" }}
      >
        Add Candidate
      </Typography>
      <Box mt={3}>
        <form>
          {/* Grid 1: Personal Information */}
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <TextField
                label="First Name"
                variant="outlined"
                id="outlined-size-normal"
                fullWidth
                name="firstname"
                value={formData.firstname}
                onChange={handleChange}
                size="small"
                error={firstNameError}
                helperText={firstNameError ? "First Name is required" : ""}
                InputLabelProps={{
                  style: { fontSize: "13px" }, // Adjust the font size as needed
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <span style={{ color: "red" }}>*</span>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Middle Name"
                variant="outlined"
                size="small"
                fullWidth
                name="middlename"
                value={formData.middlename}
                onChange={handleChange}
                InputLabelProps={{
                  style: { fontSize: "13px" }, // Adjust the font size as needed
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Last Name"
                size="small"
                variant="outlined"
                fullWidth
                name="lastname"
                error={lastNameError}
                helperText={lastNameError ? "Last Name is required" : ""}
                value={formData.lastname}
                onChange={handleChange}
                InputLabelProps={{
                  style: { fontSize: "13px" }, // Adjust the font size as needed
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <span style={{ color: "red" }}>*</span>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                label="Email"
                variant="outlined"
                fullWidth
                name="email"
                type="email"
                size="small"
                error={emailError} // Step 3
                helperText={emailError && "Email is required"} // Step 3
                value={formData.email}
                onChange={handleChange}
                InputLabelProps={{
                  style: { fontSize: "13px" }, // Adjust the font size as needed
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <span style={{ color: "red" }}>*</span>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                label="Phone"
                variant="outlined"
                size="small"
                fullWidth
                name="phone"
                type="tel"
                value={formData.phone}
                onChange={handleChange}
                InputLabelProps={{
                  style: { fontSize: "13px" }, // Adjust the font size as needed
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                label="Date of Birth"
                variant="outlined"
                size="small"
                fullWidth
                name="date_of_birth"
                type="date"
                InputLabelProps={{
                  shrink: true,
                  style: { fontSize: "13px" },
                }}
                value={formData.date_of_birth}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={4}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel>Candidate Status</InputLabel>
                <Select
                  name="candidate_status"
                  size="small"
                  value={formData.candidate_status}
                  onChange={handleChange}
                  label="Candidate Status"
                  InputLabelProps={{
                    style: { fontSize: "12px" }, // Adjust the font size as needed
                  }}
                  error={candidateStatusError}
                  helperText={candidateStatusErrorMessage}
                >
                  <MenuItem value="Active" style={{ fontSize: "12px" }}>
                    Active
                  </MenuItem>
                  <MenuItem value="Inactive" style={{ fontSize: "12px" }}>
                    Inactive
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <TextField
                label="Job Title"
                variant="outlined"
                size="small"
                fullWidth
                name="jobtitle"
                value={formData.jobtitle}
                error={jobTitleError}
                helperText={jobTitleError ? "Job Title is required" : ""}
                InputLabelProps={{
                  style: { fontSize: "12px" }, // Adjust the font size as needed
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <span style={{ color: "red" }}>*</span>
                    </InputAdornment>
                  ),
                }}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={4}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel>Work Authorization</InputLabel>
                <Select
                  name="visatype"
                  value={formData.visatype}
                  size="small"
                  onChange={handleChange}
                  label="Work Authorization"
                  InputLabelProps={{
                    style: { fontSize: "12px" }, // Adjust the font size as needed
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <span style={{ color: "red" }}>*</span>
                      </InputAdornment>
                    ),
                  }}
                >
                  <MenuItem value="GC" style={{ fontSize: "13px" }}>
                    GC
                  </MenuItem>
                  <MenuItem value="USC" style={{ fontSize: "13px" }}>
                    USC
                  </MenuItem>
                  <MenuItem value="L1" style={{ fontSize: "13px" }}>
                    L1
                  </MenuItem>
                  <MenuItem value="H1" style={{ fontSize: "13px" }}>
                    H1
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          {/* Grid 2: Professional Information */}
          <Grid container spacing={2} mt={1}>
            <Grid item xs={4}>
              <TextField
                label="Experience"
                size="small"
                variant="outlined"
                fullWidth
                name="experience"
                value={formData.experience}
                onChange={handleChange}
                error={experienceError}
                helperText={experienceError ? "Experience is required" : ""}
                InputLabelProps={{
                  style: { fontSize: "12px" }, // Adjust the font size as needed
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <span style={{ color: "red" }}>*</span>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                label="Address"
                size="small"
                variant="outlined"
                fullWidth
                name="address"
                value={formData.address}
                onChange={handleChange}
                InputLabelProps={{
                  style: { fontSize: "12px" }, // Adjust the font size as needed
                }}
              />
            </Grid>
            {/* <Grid item xs={4}>
            <FormControl
                variant="outlined"
                fullWidth
                size="small"
                
              >
                <InputLabel id="Zipcode-label" style={{ fontSize: "12px" }}>
                  Zipcode
                </InputLabel>
              <Select
                label="Zip"
                variant="outlined"
                fullWidth
                size="small"
                name="zipcode"
                value={formData.zipcode}
                onChange={handleChange}
                InputLabelProps={{
                  style: { fontSize: "12px" }, // Adjust the font size as needed
                }}
              >
                {zipcodesList?.length > 0 &&
                    zipcodesList?.map((zip) => (
                      <MenuItem key={zip.id} value={zip.id}>
                        {zip.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid> */}
            <Grid item xs={4}>
              <TextField
                label="Zip"
                variant="outlined"
                fullWidth
                size="small"
                name="zipcode"
                value={formData.zipcode}
                onChange={handleChange}
                InputLabelProps={{
                  style: { fontSize: "12px" }, // Adjust the font size as needed
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControl
                variant="outlined"
                fullWidth
                size="small"
                error={countryError}
              >
                <InputLabel id="country-label" style={{ fontSize: "12px" }}>
                  Country
                </InputLabel>
                <Select
                  labelId="country-label"
                  id="country-select"
                  value={formData.countryid}
                  onChange={handleCountryChange}
                  label="Country"
                  name="countryid"
                  size="small"
                  error={countryError} // Add this line for country validation
                  helperText={countryError ? "Country is required" : ""} // Add this line for country validation
                >
                  {/* Assuming countries is an array of country objects with id and name properties */}
                  {countriesList?.length > 0 &&
                    countriesList?.map((country, index) => (
                      <MenuItem key={index} value={country.id}>
                        {country.name}
                      </MenuItem>
                    ))}
                </Select>
                {countryError && (
                  <Typography variant="caption" color="error">
                    Country is required
                  </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControl
                variant="outlined"
                fullWidth
                size="small"
                error={stateError}
              >
                <InputLabel id="state-label" style={{ fontSize: "12px" }}>
                  State
                </InputLabel>
                <Select
                  labelId="state-label"
                  size="small"
                  variant="outlined"
                  fullWidth
                  name="stateid"
                  value={formData.stateid}
                  onChange={handleStateChange}
                  InputLabelProps={{
                    style: { fontSize: "12px" },
                  }}
                >
                  {statesList?.length > 0 &&
                    statesList?.map((state, index) => (
                      <MenuItem key={index} value={state.id}>
                        {state.name}
                      </MenuItem>
                    ))}
                </Select>
                {stateError && (
                  <Typography variant="caption" color="error">
                    State is required
                  </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControl
                variant="outlined"
                fullWidth
                size="small"
                error={cityError}
              >
                <InputLabel id="city-label" style={{ fontSize: "12px" }}>
                  City
                </InputLabel>
                <Select
                  label="City"
                  size="small"
                  variant="outlined"
                  fullWidth
                  name="cityid"
                  value={formData.cityid}
                  onChange={handleCitiesChange}
                  InputLabelProps={{
                    style: { fontSize: "12px" }, // Adjust the font size as needed
                  }}
                >
                  {citiesList?.length > 0 &&
                    citiesList?.map((city, index) => (
                      <MenuItem key={index} value={city.id}>
                        {city.name}
                      </MenuItem>
                    ))}
                </Select>
                {cityError && (
                  <Typography variant="caption" color="error">
                    City is required
                  </Typography>
                )}
              </FormControl>
            </Grid>
          </Grid>

          {/* Grid 3: Additional Information */}
          <Grid container spacing={2} mt={1}>
            <Grid item xs={12} sm={4}>
              <TextField
                label="LinkedIn URL"
                size="small"
                variant="outlined"
                InputLabelProps={{
                  style: { fontSize: "12px" }, // Adjust the font size as needed
                }}
                fullWidth
                name="linkedInUrl"
                value={formData.linkedInUrl}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel>Willing to Relocate</InputLabel>
                <Select
                  name="willingToRelocate"
                  value={formData.willingToRelocate}
                  onChange={handleChange}
                  InputLabelProps={{
                    style: { fontSize: "12px" }, // Adjust the font size as needed
                  }}
                  label="Willing to Relocate"
                  size="small"
                >
                  <MenuItem value="Yes" style={{ fontSize: "13px" }}>
                    Yes
                  </MenuItem>
                  <MenuItem value="No" style={{ fontSize: "13px" }}>
                    No
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={4}>
              <FormControl
                variant="outlined"
                fullWidth
                size="small"
                error={jobTypeError}
              >
                <InputLabel style={{ fontSize: "15px" }}>Job Type</InputLabel>
                <Select
                  name="jobtypeid"
                  value={formData.jobtypeid}
                  onChange={handleJobTypeChange}
                  label={
                    <Typography style={{ fontSize: "14px" }}>
                      Job Type
                    </Typography>
                  }
                  size="small"
                >
                  {jobTypesList?.length > 0 &&
                    jobTypesList?.map((jobType, index) => (
                      <MenuItem key={index} value={jobType.id}>
                        {jobType.title}
                      </MenuItem>
                    ))}
                </Select>
                {jobTypeError && (
                  <Typography variant="caption" color="error">
                    Job Type is required
                  </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Available Date"
                variant="outlined"
                fullWidth
                size="small"
                name="availabledate"
                type="date"
                InputLabelProps={{
                  shrink: true,

                  style: { fontSize: "13px" }, // Adjust the font size as needed
                }}
                value={formData.availabledate}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                variant="outlined"
                label={
                  <Typography style={{ fontSize: "15px" }}>
                    Expected Rate
                  </Typography>
                }
                size="small"
                fullWidth
                name="expectedRate"
                value={formData.expectedRate}
                onChange={handleChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">$</InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Expected Rate From"
                variant="outlined"
                fullWidth
                size="small"
                name="ratefrom"
                value={formData.ratefrom}
                onChange={handleChange}
                InputProps={{
                  style: { fontSize: "13px" },
                  startAdornment: (
                    <InputAdornment position="start">$</InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Expected Rate To"
                variant="outlined"
                fullWidth
                size="small"
                name="rateto"
                value={formData.rateto}
                onChange={handleChange}
                InputProps={{
                  style: { fontSize: "13px" },
                  startAdornment: (
                    <InputAdornment position="start">$</InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel style={{ fontSize: "13px" }}>Gender</InputLabel>
                <Select
                  name="gender"
                  size="small"
                  value={formData.gender}
                  onChange={handleChange}
                  label="Gender"
                  InputLabelProps={{
                    style: { fontSize: "12px" }, // Adjust the font size as needed
                  }}
                >
                  <MenuItem value="Male" style={{ fontSize: "13px" }}>
                    Male
                  </MenuItem>
                  <MenuItem value="Female" style={{ fontSize: "13px" }}>
                    Female
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                label="Current Rate"
                variant="outlined"
                size="small"
                fullWidth
                name="currentrate"
                value={formData.currentrate}
                onChange={handleChange}
                InputProps={{
                  style: { fontSize: "13px" },
                  startAdornment: (
                    <InputAdornment position="start">$</InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                label="Current Rate Type"
                size="small"
                variant="outlined"
                fullWidth
                name="currentratetype"
                value={formData.currentratetype}
                onChange={handleChange}
                InputLabelProps={{
                  style: { fontSize: "13px" }, // Adjust the font size as needed
                }}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                // label="Resumes"
                variant="outlined"
                size="small"
                fullWidth
                name="resumes"
                type="file"
                error={resumeError}
                helperText={resumeError ? "Resume is required" : ""}
                InputProps={{
                  multiple: true,
                }}
                onChange={(event) => handleFileChange(event)}
              />
              <span>{fileName && fileName}</span>
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                label={
                  <React.Fragment>
                    Related Titles
                    <span style={{ color: "red" }}>*</span>
                  </React.Fragment>
                }
                variant="outlined"
                size="small"
                fullWidth
                name="related_titles"
                value={formData.related_titles}
                error={relatedtitlesError}
                helperText={
                  relatedtitlesError ? "Related Titles are required" : ""
                }
                onChange={handleChange}
                InputLabelProps={{
                  style: { fontSize: "15px" }, // Adjust the font size as needed
                }}
                multiline
                // rows={5}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              {/* <FormControl fullWidth>
                <Typography variant="subtitle1" gutterBottom>
                  Description
                </Typography> */}
              <ReactQuill
                value={formData.summary}
                onChange={handleEditorChange}
                modules={{
                  toolbar: [["bold", "italic", "underline", "strike", "link"]],
                }}
                theme="snow"
                placeholder="Enter Description"
                style={{ height: "90px" }}
              />
              {/* </FormControl> */}
            </Grid>
          </Grid>

          {/* Submit Button */}
          <Grid item xs={12}>
            <Box
              sx={{ display: "flex", justifyContent: "end", gap: 2, mt: 10 }}
            >
              <Button
                variant="outlined"
                // color="primary"
                size="small"
                fullWidth
                onClick={() => setAddCandidateFormOpen(false)}
                style={{ width: 120 }}
                disabled={disabled}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="small"
                fullWidth
                onClick={handleSubmit}
                style={{ width: 120 }}
                disabled={disabled}
              >
                Submit
              </Button>
            </Box>
          </Grid>
          {/* {resumeError && (
  <Typography variant="caption" color="error">
    Resume is required
  </Typography>
)} */}
        </form>
      </Box>
    </Container>
  );
}

export default AddCandidate;
